import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import head from 'lodash/head';
import tail from 'lodash/tail';

import { makeStyles } from '@material-ui/core/styles';
import { Button, Fade } from '@material-ui/core';

import { Icon, Label } from '@hydra/common/components';

import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';

const useStyles = makeStyles(theme => ({
  ul: {
    listStyleType: 'none',
    padding: `${theme.spacing(0.25)}px 0`
  },
  li: {
    display: 'flex',
    alignItems: 'center'
  },
  anchor: {
    padding: theme.spacing(0, 1)
  }
}));

function LinkMaybe ({ children, url, icon, className }) {
  const classes = useStyles();
  const [hover, setHover] = useState(false);
  const handleHoverOut = () => setHover(false);
  const handleHoverOver = () => setHover(true);
  return url.fullPath
    ? (
      <Button
        href={url.fullPath}
        target='_blank'
        rel='nofollow noopener noreferrer'
        startIcon={icon}
        onMouseEnter={handleHoverOver}
        onMouseLeave={handleHoverOut}
        className={classes.anchor}
        endIcon={<Fade in={hover}><Icon size='xs' type='external-link' /></Fade>}
      >
        {children}
      </Button>
      )
    : children;
}

export function VisualLinkIssue ({ urls, icon, severity, extraClass = '', ...props }) {
  const classes = useStyles();
  const firstUrl = head(urls) || {};
  const urlList = tail(urls);

  return (
    <div>
      <ul className={classes.ul}>
        <li className={classnames(classes.li)}>
          <LinkMaybe url={firstUrl}>
            <Label noBackground truncate title={firstUrl.visibleUrl}>{firstUrl.visibleUrl}</Label>
          </LinkMaybe>
        </li>
        {
          urlList.map((url, pos) =>
            <li key={url.id} className={classnames(classes.li, extraClass)}>
              <LinkMaybe
                url={url}
                icon={
                  (urlList.length === pos + 1)
                    ? (
                      <Icon size='md' type={icon} color={parseSeverity(severity)} />
                      )
                    : (icon === 'broken-redirect' || icon === 'redirect-chain')
                        ? (
                          <Icon size='md' type='simple-redirect' color='grey' />
                          )
                        : null
                }
              >
                <Label
                  title={url.visibleUrl}
                  truncate
                  noBackground
                >
                  {url.visibleUrl}
                </Label>
              </LinkMaybe>
            </li>)
        }
      </ul>
    </div>
  );
}

VisualLinkIssue.propTypes = {
  extraClass: PropTypes.string,
  severity: PropTypes.number,
  icon: PropTypes.string,
  urls: PropTypes.arrayOf(PropTypes.instanceOf(DCUrl))
};

export default VisualLinkIssue;
